<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
        <!-- 提交按钮 -->
        <div class="pageButton">
          <button type="button" class="btn btn-primary" @click="clkApply()">
            {{ "Apply" }}
          </button>
          <span style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-default"
              style="min-width: 77px"
              @click="clkCancel()"
            >
              {{ "Cancel" }}
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ page.desc }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- LACP表信息 -->
        <block-cntr :btitle="page.blkTitle.lacp" style="height: 100%">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="
                    loadLacp()
                    loadLacpNeighbor()
                  "
                  class="btn"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction" title="refresh"></i>
                </div>
              </div>
            </span>
            <!-- 选择汇聚组按钮 -->
            <span style="float: right">
              <select class="form-control" v-model="selectedChannel">
                <option
                  v-if="lacpTable.data && lacpTable.data.length === 0"
                  value="-1"
                >
                  No channel
                </option>
                <option
                  v-for="opt in lacpTable.data"
                  :key="opt.channel"
                  :value="opt.channel"
                >
                  {{
                    "channel " +
                    opt.channel +
                    (opt["dynamic"] ? "  (dynamic)" : "  (static)")
                  }}
                </option>
              </select>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in calcLacpTableTitle"
                  :key="key"
                  :title="
                    key === 'actstate' || key === 'neistate'
                      ? 'activity/timeout/aggregation/synchronization/collecting/distributing/defaulted/expired'
                      : value
                  "
                  :style="{ width: key === 'id' ? '100px' : 'auto' }"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: auto">
              <tr v-for="row in calcLacpTable" :key="row.port">
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  :title="value"
                  :style="{ width: key === 'id' ? '100px' : 'auto' }"
                >
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- LACP端口配置 -->
        <block-cntr :btitle="page.blkTitle.port" style="height: 100%">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div
                @click="editSelectRow"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-edit page-tableaction" title="edit"></i>
              </div>
            </span>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    @change="selectall()"
                    v-model="selall"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in lacpPortTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: auto">
              <tr
                v-for="row in lacpPortTable.data"
                :key="row.port"
                :class="{
                  info: row.rowStatus === 'edit',
                }"
                @dblclick="editDoubleClickRow(row)"
                @click="
                  row.selected =
                    row.rowStatus === '' ? !row.selected : row.selected
                "
                style="
                  -moz-user-select: none; /*火狐*/
                  -webkit-user-select: none; /*webkit浏览器*/
                  -ms-user-select: none; /*IE10*/
                  -khtml-user-select: none; /*早期浏览器*/
                  user-select: none;
                "
              >
                <td width="40px">
                  <div v-if="row.rowStatus === ''">
                    <input type="checkbox" v-model="row.selected" />
                    <label></label>
                  </div>
                  <div v-else class="revocate" @click.stop="undoRow(row)">
                    <i class="fa fa-undo"></i>
                  </div>
                </td>
                <td
                  v-for="(value, key) in row"
                  :key="key"
                  :title="value"
                  v-show="
                    key !== 'rowStatus' &&
                    key !== 'selected' &&
                    key !== 'newchannel' &&
                    key !== 'newmode'
                  "
                >
                  <!-- 端口汇聚组配置 -->
                  <div v-if="key === 'channel' && row.rowStatus === 'edit'">
                    <select
                      class="form-control table-edit"
                      v-model="row['newchannel']"
                      style="width: 90px"
                    >
                      <option :value="-1">{{ "None" }}</option>
                      <option
                        v-for="opt in lacpPortTable.maxchannel"
                        :key="opt - 1"
                        :value="opt - 1"
                      >
                        {{ "channel " + (opt - 1) }}
                      </option>
                    </select>
                  </div>
                  <!-- 端口汇聚组模式配置 -->
                  <div
                    v-else-if="
                      key === 'mode' &&
                      row['rowStatus'] === 'edit' &&
                      row['newchannel'] !== -1
                    "
                  >
                    <select
                      class="form-control table-edit"
                      v-model="row['newmode']"
                      style="width: 90px"
                    >
                      <option
                        v-for="(value, key) in ['on', 'active', 'passive']"
                        :key="key"
                        :value="value"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "./../components/InfoBox.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "lacp",
  components: {
    BlockCntr,
    InfoBox,
  },
  data() {
    return {
      page: en.page.lacp,
      lacpTable: "",
      lacpNeighborTable: "",
      lacpPortTable: "",
      selall: false,
      selectedChannel: -1,
      iBox: {},
    }
  },
  created() {
    this.loadLacp()
    this.loadLacpNeighbor()
    this.loadLacpPort()
  },
  methods: {
    loadLacp() {
      get("lacp")
        .then((res) => {
          this.lacpTable = res.data
          if (
            this.lacpTable.data.length &&
            this.lacpTable.data[0].channel !== undefined
          )
            this.selectedChannel = this.lacpTable.data[0].channel
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    loadLacpNeighbor() {
      get("lacpneighbor")
        .then((res) => (this.lacpNeighborTable = res.data))
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    loadLacpPort() {
      get("lacpport")
        .then((res) => {
          this.lacpPortTable = res.data
          this.dataInit()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面数据初始化 */
    dataInit() {
      this.lacpPortTable.data.forEach((element) => {
        this.$set(element, "rowStatus", "")
        this.$set(element, "selected", false)
        this.$set(
          element,
          "newchannel",
          element["channel"] === "" ? -1 : element["channel"]
        )
        this.$set(
          element,
          "newmode",
          element["mode"] === "" ? "on" : element["mode"]
        )
      })
      this.selall = false
    },

    /* 页面提交函数 */
    clkApply() {
      var postData = {}
      var editRows = []

      this.lacpPortTable.data.forEach((o) => {
        if (o["rowStatus"] !== "edit") return
        if (
          (o["newchannel"] === -1 && o["channel"] === "") ||
          (o["newchannel"] == o["channel"] && o["newmode"] === o["mode"])
        )
          return

        if (o["newchannel"] === -1)
          editRows.push({ port: o["port"], channel: o["newchannel"] })
        else
          editRows.push({
            port: o["port"],
            channel: o["newchannel"],
            mode: o["newmode"],
          })
      })

      if (!editRows.length) {
        this.showAlertBox("info", "info", "Nothing to do!")
        return
      }
      postData["edit"] = editRows
      post("lacpport", postData)
        .then((res) => {
          if (
            res.data.code === undefined ||
            (res.data.code === 0 && res.data.msg === undefined)
          )
            this.showAlertBox("info", "Info", "Config Successful!")
          else
            this.showAlertBox(
              res.data.code === 0 ? "info" : "warn",
              res.data.code === 0 ? "Info" : "Warn",
              res.data.msg !== undefined ? res.data.msg : "Unknow error!"
            )
          this.loadLacp()
          this.loadLacpNeighbor()
          this.loadLacpPort()
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    /* 页面恢复函数 */
    clkCancel() {
      this.dataInit()
    },

    /* 双击编辑行 */
    editDoubleClickRow(row) {
      if (row["rowStatus"] === "") {
        row["rowStatus"] = "edit"
      }
    },

    /* 编辑选择的行 */
    editSelectRow() {
      this.lacpPortTable.data.forEach((element) => {
        if (element["rowStatus"] === "" && element["selected"]) {
          element["rowStatus"] = "edit"
          element["selected"] = false
        }
      })
    },

    /* 撤销行操作 */
    undoRow(row) {
      if (row["rowStatus"] === "edit") {
        row["rowStatus"] = ""
        row["selected"] = false
      }
    },

    /* 选择全部行 */
    selectall() {
      this.lacpPortTable.data.forEach((element) => {
        if (element["rowStatus"] === "") element["selected"] = this.selall
      })
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
  computed: {
    /* lacp 表与邻居表标题合并 */
    calcLacpTableTitle() {
      var newTitle = Object.assign({}, this.lacpTable.title)
      if (this.lacpTable.data === undefined) return
      var lacp = this.lacpTable.data.find(
        (o) => o.channel === this.selectedChannel
      )
      if (lacp === undefined) return newTitle
      if (lacp.dynamic) {
        Object.assign(newTitle, this.lacpNeighborTable.title)
        newTitle["local"] = ""
      }
      return newTitle
    },
    /* lacp 表与邻居表数据合并 */
    calcLacpTable() {
      if (this.lacpTable.data === undefined) return

      var lacp = this.lacpTable.data.find(
        (o) => o.channel === this.selectedChannel
      )
      if (lacp === undefined) return

      if (lacp["dynamic"] !== true) return lacp.member

      if (this.lacpNeighborTable.data === undefined) return lacp.member
      var neighbor = this.lacpNeighborTable.data.find(
        (o) => o.channel === this.selectedChannel
      )
      if (neighbor === undefined) return lacp.member
      var lacpNew = []
      lacp.member.forEach((element) => {
        var neighborM = neighbor.member.find(
          (o) => o["local"] === element["port"]
        )
        if (neighborM) {
          var newN = Object.assign({}, neighborM)
          newN["local"] = ""
          lacpNew.push(Object.assign({}, element, newN))
        }
      })

      return lacpNew
    },
  },
}
</script>